import axios from 'axios';

const url = process.env.VUE_APP_HOST;
const home = process.env.VUE_APP_HOME;

const getBookingType = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/BookingType';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}


const getEventSlotPattern = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/EventSlot';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}


const postEventSlotPattern = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/EventSlot';

    let result = await axios.post(urlWithArg, JSON.stringify(payload) ,headers);
    
    return result.data;

}

const patchEventSlotPattern = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/EventSlot/'+payload.identity;

    let result = await axios.patch(urlWithArg, JSON.stringify(payload) ,headers);
    
    return result.data;

}

const delEventSlotPattern = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/EventSlot/'+id;

    let result = await axios.delete(urlWithArg ,headers);
    
    return result.data;

}


export const bookingTypeService = { getBookingType, postEventSlotPattern, patchEventSlotPattern, delEventSlotPattern, getEventSlotPattern }


// WEBPACK FOOTER //
// ./src/api/booking-type.service.js